import { render, staticRenderFns } from "./AirdropPaymentHistory.vue?vue&type=template&id=d1732f8e&scoped=true"
import script from "./AirdropPaymentHistory.vue?vue&type=script&lang=js"
export * from "./AirdropPaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./AirdropPaymentHistory.vue?vue&type=style&index=0&id=d1732f8e&prod&lang=scss&scoped=true"
import style1 from "./AirdropPaymentHistory.vue?vue&type=style&index=1&id=d1732f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1732f8e",
  null
  
)

export default component.exports